var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-wrapper"},[_c('img',{attrs:{"src":require("../assets/back.png")},on:{"click":_vm.goBack}}),_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }